(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcv-city-runner"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if(customElements.get('dcv-city-runner'))return;
  const sprites={"PLANE":["##..........................","###.........................","####........................","####........................","#####.......................","########################....","#########################...","########o#o#o#o#o#o####.....","###########################.","..##########################","...#############.##########.","..........######............","............####............"],"CLOUD":["....................####................","...............######..###..............","..............##.........##.............","............###...........#.............","............#.............###...........","............#.............#..#####......",".........####............#.......#......",".........#.......................####...","...######...........................##..","..##.................................##.",".##...................................#.","##.....................................#","########################################"],"BIRD_A":[".....####................",".....######..............",".....########............","......#########..........","......###########........",".......############......",".......##############....","#########################",".######################..","...###############.......",".....########............","......#####..............",".........................",".........................",".........................","........................."],"BIRD_B":[".........................",".........................",".........................",".........................","#########################",".######################..","....################.....",".....##############......",".....#############.......","......###########........","......#########..........",".......#######...........",".......#####.............","........###..............","........##...............","........................."]};
function mount(root) {
  const controller=new AbortController();
  const listen=(target,type,handler)=>target.addEventListener(type,handler,{signal:controller.signal});
  let active=true,frameId=0;
  const canvas = root.querySelector('.dcv-flight');
  const ctx = canvas.getContext('2d');
  if(!ctx)return ()=>{};
  const heading = root.querySelector('.dcv-game-heading');
  const counter = root.querySelector('.dcv-game-counter');
  const { PLANE, CLOUD, BIRD_A, BIRD_B } = sprites;
  const FINAL = 281, GROUND = 218, SCALE = 2, ENDING_GAP = 40;
  let viewHeight=240, towerTop=24;
  let width = 640, state = 'ready', y = 90, x = 100, vy = 0;
  let speed = 4.2, distance = 0, score = 0, held = false, tapped = false;
  let buildings = [], clouds = [], spawn = 0, last = 0, accumulator = 0;
  let visible = true;
  let birds=[], birdDistance=600;
  let crashAge = 0, particles = [], shockRing = [];
  // Cover the 300ms hint fade plus a frame before accepting a fresh restart tap.
  const RESTART_DELAY_MS = 350;
  let restartAvailableAt = 0;
  // Ending adapted from Desktop/city-runner.html to the preview's 240-unit canvas.
  const SECOND_PLANE_DELAY=45, SECOND_PLANE_START_Y=38, SECOND_PLANE_ENTRY_SPEED=3.2;
  const WING_SCALE=SCALE*2/3, ART=2;
  let walls=[], wing=null, finaleTimer=0, booms=[];
  // Stable world-space marks: the original has 140 over a 1280-unit loop.
  const cityHash=(index,salt)=>{const n=Math.sin(index*127.1+salt*311.7)*43758.5453;return n-Math.floor(n);};
  const groundSpan=1280;
  const pebbles=Array.from({length:140},(_,i)=>({x:cityHash(i,20)*groundSpan,y:4+Math.floor(cityHash(i,21)*15),w:1+Math.floor(cityHash(i,22)*7)}));
  const random = (a,b) => a + Math.random() * (b-a);
  // Every silhouette is built from the same rectangles used by collision checks.
  let buildingStyle=0, buildingIndex=0;
  function makeBuilding(px,style=buildingStyle++%4) {
    // Each building has fixed artwork, independent of refreshes and other random effects.
    const index=buildingIndex++;
    return {x:px,w:Math.round(24+cityHash(index,10)*15),h:Math.round(38+cityHash(index,11)*50),style,seed:Math.floor(cityHash(index,12)*1000),antenna:style===2?Math.round(10+cityHash(index,13)*12):0};
  }
  function buildingParts(b) {
    const parts=[{x:0,y:GROUND-b.h,w:b.w,h:b.h}];
    if(b.style===1)parts.push({x:5,y:GROUND-b.h-10,w:b.w-10,h:10},{x:9,y:GROUND-b.h-16,w:b.w-18,h:6});
    if(b.style===2)parts.push({x:Math.floor(b.w/2)-1,y:GROUND-b.h-b.antenna,w:2,h:b.antenna},{x:Math.floor(b.w/2)-3,y:GROUND-b.h-b.antenna-2,w:6,h:2});
    if(b.style===3)parts.push({x:3,y:GROUND-b.h-5,w:b.w-6,h:5});
    return parts;
  }
  function drawBuilding(b) {
    const bx=Math.round(b.x),top=GROUND-b.h;
    ctx.fillStyle='#535353';
    for(const part of buildingParts(b))ctx.fillRect(bx+part.x,part.y,part.w,part.h);
    ctx.fillStyle='#fff';
    const colStep=b.style===3?7:5,rowStep=b.style===2?8:6;
    for(let row=5;row<b.h-4;row+=rowStep){
      for(let col=3;col<b.w-4;col+=colStep){
        if((col*3+row+b.seed)%8===0)continue;
        ctx.fillRect(bx+col,top+row,b.style===3?4:3,b.style===2?3:2);
      }
    }
    if(b.style===1){ctx.fillRect(bx+8,top-7,3,2);ctx.fillRect(bx+b.w-11,top-7,3,2);}
    if(b.style===3){ctx.fillStyle='#999';ctx.fillRect(bx+2,top+2,b.w-4,1);}
  }
  const mobileLayout=window.matchMedia('(max-width: 600px)');
  function instructionText(){const replay=state==='lost'||state==='over';pixelText(heading.children[1],(mobileLayout.matches?'TAP TO FLY':'PRESS SPACE TO FLY')+(replay?' AGAIN':''));}
  listen(mobileLayout,'change',instructionText);
  function labels(title, hint) {
    if(hint&&(state==='over'||state==='lost'))restartAvailableAt=performance.now()+RESTART_DELAY_MS;
    heading.children[0].textContent = state==='lost'?'YOU WIN':'CITY RUNNER';
    instructionText();
    heading.children[1].style.opacity = hint ? '1' : '0';
    heading.children[1].setAttribute('aria-hidden', hint ? 'false' : 'true');
  }
  function pixelText(target,label) {
    target.replaceChildren(...[...label].map(character=>{
      const digit=document.createElement('span');digit.textContent=character;
      digit.className='dcv-pixel-char';digit.setAttribute('data-glyph',character.charCodeAt(0));
      return digit;
    }));
  }
  function updateCounter(value) {
    const label=String(Math.floor(value/30)).padStart(2,'0')+'/'+String(value%30).padStart(2,'0');
    pixelText(counter,label);
  }
  function reset() {
    walls=[];wing=null;finaleTimer=0;booms=[];held=false;tapped=false;birds=[];birdDistance=600;crashAge=0; particles=[]; y=90; x=width*.25; vy=0; speed=4.2; distance=0; score=0; spawn=180;
    buildingIndex=0;buildingStyle=2;buildings=[makeBuilding(width*.65,0),makeBuilding(width*.9,1)]; clouds=[{x:width*.08,y:32},{x:width*.68,y:62}];
    updateCounter(0); state='ready';
    labels('CITY RUNNER','SPACE OR TAP TO FLY');
  }
  function action() {
    if((state==='over'||state==='lost')&&performance.now()<restartAvailableAt)return;
    if(state==='over'||state==='lost')reset();
    if(state==='ready'){state='run';labels('','');}
    if(state==='finale')return;
    held=true;tapped=true;
  }
  listen(canvas,'pointerdown', e => {
    if(e.button!==0)return;
    canvas.focus({preventScroll:true}); action();
    canvas.setPointerCapture(e.pointerId);
  });
  listen(root.querySelector('.dcv-city-hero'),'pointerdown',e=>{if(e.target!==canvas&&e.button===0){canvas.focus({preventScroll:true});action();}});
  listen(window,'pointerup',()=>held=false);
  ['pointerup','pointercancel','lostpointercapture'].forEach(type=>listen(canvas,type,()=>held=false));
  function key(e) {
    if(e.code!=='Space'||e.target.closest('input,textarea,select,a,button,[contenteditable=true]'))return;
    if(!visible)return;
    e.preventDefault(); if(!e.repeat)action();
  }
  listen(window,'keydown',key);
  listen(window,'keyup',e=>{if(e.code==='Space')held=false;});
  listen(window,'blur',()=>held=false);
  listen(document,'visibilitychange',()=>{held=false;last=0;accumulator=0;});
  const intersectionObserver=new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;if(!visible)held=false;last=0;},{threshold:.1});
  intersectionObserver.observe(canvas);
  const resizeObserver=new ResizeObserver(()=>{
    const rect=canvas.getBoundingClientRect();
    if(rect.width<=0||rect.height<=0)return;
    const previous=width;
    // Zoom the whole scene out on phones, anchored to the ground.
    viewHeight=mobileLayout.matches?320:240;
    towerTop=mobileLayout.matches?8:24;
    width=Math.max(300,viewHeight*rect.width/rect.height);
    const shift=(width-previous)/2;
    if(walls.length){
      walls.forEach(w=>w.x+=shift);x+=shift;
      if(wing)wing.x+=shift;
      booms.forEach(b=>b.x+=shift);
    }else x=x/previous*width;
    canvas.width=Math.round(rect.width*devicePixelRatio);canvas.height=Math.round(rect.height*devicePixelRatio);
    if(state==='ready')reset();
    render();
  });
  resizeObserver.observe(canvas);
  function sprite(rows,px,py,size,colour) {
    // Fill each sprite colour as one path, matching the original solid pixel shapes.
    for (const pixel of ['#','o']) {
      ctx.beginPath();
      rows.forEach((row,j)=>[...row].forEach((value,i)=>{
        if(value===pixel)ctx.rect(px+i*size,py+j*size,size,size);
      }));
      ctx.fillStyle=pixel==='o'?'#fff':colour;ctx.fill();
    }
  }

  function finish() {
    state='over';held=false;
    crashAge=0;
    particles=Array.from({length:30},(_,i)=>({angle:i/30*Math.PI*2+random(-.12,.12),speed:random(1.5,4.6),size:(1+Math.floor(random(0,3)))*2,drop:random(.02,.09)}));
    shockRing=Array.from({length:34},(_,i)=>({angle:i/34*Math.PI*2,jitter:random(.74,1.18),big:Math.random()<.4}));
    labels('TRY AGAIN','SPACE OR TAP TO FLY AGAIN');
  }
  function makeBoom(x, y, scale = 1) {
    const parts = [], ring = [];
    for (let i = 0; i < 30; i++) {
      parts.push({
        a: (i / 30) * Math.PI * 2 + random(-0.12, 0.12),
        sp: random(1.5, 4.6) * scale,
        size: Math.max(ART, Math.round(Math.floor(random(1, 4)) * scale) * ART),
        drop: random(0.02, 0.09) * scale
      });
    }
    for (let i = 0; i < 34; i++) {                  // lumpy, so the ring never reads as a circle
      ring.push({ a: (i / 34) * Math.PI * 2, jit: random(0.74, 1.18), big: Math.random() < 0.4 });
    }
    booms.push({ x, y, t: 0, scale, parts, ring });
  }

  function drawBoom(boom) {
    const bt = boom.t;
    const sc = boom.scale || 1;
    const snap = v => Math.round(v / ART) * ART;
    ctx.fillStyle = '#535353';

    if (bt < 5) {                                   // the hit: a small ragged burst
      const r = (6 + bt * 2) * sc;
      for (const k of boom.ring) {
        const rr = r * k.jit;
        for (let q = 0; q <= rr; q += ART) {
          ctx.fillRect(snap(boom.x + Math.cos(k.a) * q), snap(boom.y + Math.sin(k.a) * q), ART, ART);
        }
      }
    }
    if (bt >= 3 && bt < 30) {                       // the shock ring opening out and thinning
      const r = (12 + (bt - 3) * 3.2) * sc;
      for (let i = 0; i < boom.ring.length; i++) {
        if (bt > 18 && i % 2) continue;
        const k = boom.ring[i];
        const rr = r * k.jit;
        const s = (k.big && bt < 16 && sc > 0.75) ? ART * 2 : ART;
        ctx.fillRect(snap(boom.x + Math.cos(k.a) * rr), snap(boom.y + Math.sin(k.a) * rr), s, s);
      }
    }

    for (const p of boom.parts) {                   // debris, thrown out and falling
      const d = p.sp * bt;
      const px = boom.x + Math.cos(p.a) * d;
      const py = boom.y + Math.sin(p.a) * d + p.drop * bt * bt;
      if (py > GROUND) continue;
      const s = Math.max(ART, p.size - Math.floor(bt / 12) * ART);
      ctx.fillRect(snap(px), snap(py), s, s);
    }
  }


  function drawWall(o) {
    const wx=Math.round(o.x);
    ctx.fillStyle='#535353';ctx.fillRect(wx,towerTop,o.w,GROUND-towerTop);
    ctx.fillStyle='#fff';
    for(let wy=towerTop+10;wy<GROUND-5;wy+=8)
      for(let col=3;col<o.w-4;col+=6)ctx.fillRect(wx+col,wy,4,3);
  }
  function startFinalImpact() {
    x=walls[0].x-25*SCALE;
    y=Math.max(y,towerTop+4-7*SCALE);
    vy=0;held=false;tapped=false;
    state='finale';finaleTimer=0;
    wing={x:-28*WING_SCALE-8,y:SECOND_PLANE_START_Y,vy:0,visible:false,hit:false};
    makeBoom(x+28*SCALE,y+PLANE.length*SCALE/2);
  }
  function stepFinale() {
    if(++finaleTimer<SECOND_PLANE_DELAY)return;
    wing.visible=true;
    // Tie descent to remaining horizontal travel, so every viewport hits mid-tower.
    const remaining=walls[1].x-25*WING_SCALE-wing.x;
    const advance=Math.min(SECOND_PLANE_ENTRY_SPEED,Math.max(0,remaining));
    const targetY=(GROUND+towerTop)/2-PLANE.length*WING_SCALE/2;
    wing.vy=(targetY-wing.y)*(remaining>0?advance/remaining:1);
    wing.y+=wing.vy;
    wing.x+=advance;
    if(remaining<=SECOND_PLANE_ENTRY_SPEED){
      wing.x=walls[1].x-25*WING_SCALE;wing.hit=true;wing.vy=0;
      makeBoom(wing.x+28*WING_SCALE,wing.y+PLANE.length*WING_SCALE/2,.62);
      state='lost';held=false;tapped=false;labels('YOU LOST','VIOLENCE IS WRONG');
    }
  }

  function step() {
    for(const b of booms)if(b.t<90)b.t++;
    if(state==='finale'){stepFinale();return;}
    if(state==='over'){crashAge++;return;}
    if(state!=='run'&&state!=='closing'&&state!=='approach')return;
    if(tapped&&vy>-2.2)vy=-3;
    tapped=false;vy=Math.max(-4.8,Math.min(5.4,vy+(held?-.44:.26)));
    y+=vy;if(y<8){y=8;vy=0;}
    if(state==='run') {
      speed=Math.min(11.5,speed+.0016);distance+=speed;
      score=Math.min(FINAL,Math.floor(distance/18));
      updateCounter(score);
      buildings.forEach(b=>b.x-=speed);buildings=buildings.filter(b=>b.x+b.w>0);
      birds.forEach(b=>{b.x-=speed*1.15;b.frame+=.15;});
      birds=birds.filter(b=>b.x+25>0);
      birdDistance-=speed;
      if(birdDistance<=0&&score>20&&score<FINAL){
        birds.push({x:width+20,y:[45,85,120][Math.floor(random(0,3))],frame:0});
        birdDistance=random(900,1400);
      }
      spawn-=speed;
      if(spawn<=0&&score<FINAL){buildings.push(makeBuilding(width));spawn=250+cityHash(buildingIndex,14)*120;}
      clouds.forEach(c=>{c.x-=speed*.12;if(c.x+80<0){c.x=Math.max(width,...clouds.filter(q=>q!==c).map(q=>q.x+140));c.y=random(24,64);}});
      // Leave a little extra space after the last buildings before the tower pair.
      if(score===FINAL){state='closing';walls=[{x:width+30+ENDING_GAP,w:24},{x:width+66+ENDING_GAP,w:24}];labels('','');}
    } else if(state==='closing'){
      speed=Math.min(11.5,speed+.0016);
      const scroll=Math.min(speed,Math.max(0,walls[0].x-(width-60)/2));
      walls.forEach(w=>w.x-=scroll);distance+=scroll;
      buildings.forEach(b=>b.x-=scroll);
      birds.forEach(b=>{b.x-=scroll*1.15;b.frame+=.15;});
      clouds.forEach(c=>c.x-=scroll*.12);
      if(walls[0].x<=(width-60)/2)state='approach';
    } else {
      speed=Math.min(11.5,speed+.0016);
      x=Math.min(walls[0].x-25*SCALE,x+speed);
    }
    if(walls.length&&x+25*SCALE>=walls[0].x){startFinalImpact();return;}
    if(birds.some(b=>x+25*SCALE>b.x+3&&x+3*SCALE<b.x+21&&y+9.5*SCALE>b.y+4&&y+5.7*SCALE<b.y+11)){finish();return;}
    if(buildings.some(b=>buildingParts(b).some(p=>x+25*SCALE>b.x+p.x&&x+3*SCALE<b.x+p.x+p.w&&y+9.5*SCALE>p.y&&y+5.7*SCALE<p.y+p.h))){finish();return;}
    if(y+PLANE.length*SCALE>=GROUND){
      y=GROUND-PLANE.length*SCALE;
      finish();
    }
  }
  function render() {
    ctx.setTransform(canvas.width/width,0,0,canvas.height/viewHeight,0,(viewHeight-240)*canvas.height/viewHeight);
    ctx.clearRect(0,240-viewHeight,width,viewHeight);ctx.imageSmoothingEnabled=false;
    const offset=distance*.22,cell=48;
    const start=Math.floor(offset/cell);
    for(let index=start-1;index<start+Math.ceil(width/cell)+2;index++){
      if(cityHash(index,1)<.14)continue;
      const bx=Math.round(index*cell-offset+cityHash(index,2)*8);
      const w=16+Math.floor(cityHash(index,3)*28),h=20+Math.floor(cityHash(index,4)*66);
      const top=GROUND-30-h,style=Math.floor(cityHash(index,5)*4);
      ctx.fillStyle=style===3?'#dedede':'#d4d4d4';ctx.fillRect(bx,top,w,h);
      if(style===1){ctx.fillRect(bx+4,top-8,w-8,8);ctx.fillRect(bx+8,top-13,Math.max(3,w-16),5);}
      if(style===2){const antenna=8+Math.floor(cityHash(index,6)*16);ctx.fillRect(bx+Math.floor(w/2),top-antenna,2,antenna);}
      if(style===3){ctx.fillStyle='#e9e9e9';for(let row=8;row<h-4;row+=10)ctx.fillRect(bx+3,top+row,w-6,1);}
    }
    ctx.fillStyle='#c2c2c2';ctx.fillRect(0,GROUND-31,width,2);
    clouds.forEach(c=>sprite(CLOUD,c.x,c.y,2,'#d4d4d4'));
    buildings.forEach(drawBuilding);
    birds.forEach(b=>sprite(Math.floor(b.frame)%2?BIRD_B:BIRD_A,Math.round(b.x),b.y,1,'#535353'));
    ctx.fillStyle='#535353';ctx.fillRect(0,GROUND,width,2);
    walls.forEach(drawWall);
    if(state==='over'&&crashAge<90){
      const age=crashAge, art=2;
      const snap=value=>Math.round(value/art)*art;
      const cx=x+25*SCALE, cy=Math.min(GROUND-4,y+9*SCALE);
      ctx.fillStyle='#535353';
      // Original burst: a ragged impact, then a thinning shock ring and falling chunks.
      if(age<5){
        const radius=6+age*2;
        for(const k of shockRing)for(let q=0;q<=radius*k.jitter;q+=art)
          ctx.fillRect(snap(cx+Math.cos(k.angle)*q),snap(cy+Math.sin(k.angle)*q),art,art);
      }
      if(age>=3&&age<30){
        const radius=12+(age-3)*3.2;
        shockRing.forEach((k,i)=>{
          if(age>18&&i%2)return;
          const size=k.big&&age<16?4:2;
          ctx.fillRect(snap(cx+Math.cos(k.angle)*radius*k.jitter),snap(cy+Math.sin(k.angle)*radius*k.jitter),size,size);
        });
      }
      for(const p of particles){
        const px=cx+Math.cos(p.angle)*p.speed*age;
        const py=cy+Math.sin(p.angle)*p.speed*age+p.drop*age*age;
        if(py>GROUND)continue;
        const size=Math.max(art,p.size-Math.floor(age/12)*art);
        ctx.fillRect(snap(px),snap(py),size,size);
      }
    }
    ctx.save();
    const tilt=state==='run'||state==='closing'||state==='approach'?Math.max(-2,Math.min(2,Math.round(vy/2.6))):0;
    ctx.translate(Math.round(x+28*SCALE/2),Math.round(y+13*SCALE/2+tilt));
    if(state==='over'||state==='finale'||state==='lost')ctx.rotate(.45);
    sprite(PLANE,-28*SCALE/2,-13*SCALE/2,SCALE,'#555');
    ctx.restore();
    if(wing&&wing.visible){
      ctx.save();ctx.translate(Math.round(wing.x+14*WING_SCALE),Math.round(wing.y+6.5*WING_SCALE));
      if(wing.hit)ctx.rotate(.45);
      sprite(PLANE,-14*WING_SCALE,-6.5*WING_SCALE,WING_SCALE,'#555');ctx.restore();
    }
    for(const b of booms)if(b.t<90)drawBoom(b);
    ctx.fillStyle='#535353';
    const groundOffset=distance%groundSpan;
    for(let tile=-1;tile<=Math.ceil(width/groundSpan);tile++){
      for(const p of pebbles){
        const px=p.x+tile*groundSpan-groundOffset;
        if(px>=-8&&px<=width)ctx.fillRect(Math.round(px),GROUND+p.y,p.w,1);
      }
    }
  }
  function frame(now) {
    if(!active)return;
    if(!last)last=now;
    if(visible&&!document.hidden){accumulator+=Math.min(100,now-last);while(accumulator>=1000/60){step();accumulator-=1000/60;}render();}
    last=now;frameId=requestAnimationFrame(frame);
  }
  reset();frameId=requestAnimationFrame(frame);
  return ()=>{
    active=false;held=false;
    cancelAnimationFrame(frameId);
    controller.abort();
    intersectionObserver.disconnect();
    resizeObserver.disconnect();
  };
}

  customElements.define('dcv-city-runner',class extends HTMLElement {
    connectedCallback(){
      queueMicrotask(()=>{
        if(this.isConnected&&!this.stop)this.stop=mount(this);
      });
    }
    disconnectedCallback(){
      if(this.stop){this.stop();this.stop=null;}
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
